import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import { MessageFrame } from './MessageFrame';
export const GetSimpleConfirmationMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const SimpleConfirmationMessage = (param)=>{
    let { content, messageId, interactive, onDismiss, onApply, onSubmitFeedback, onDismissFeedback } = param;
    const { SimpleConfirmationMessageTID } = useMemo(()=>GetSimpleConfirmationMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        width: "100%",
        children: [
            /*#__PURE__*/ _jsxs(MessageFrame, {
                testId: SimpleConfirmationMessageTID.Root(),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: SimpleConfirmationMessageTID.Intro(),
                        children: content.intro
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: SimpleConfirmationMessageTID.Question(),
                        children: content.question
                    }),
                    interactive && /*#__PURE__*/ _jsxs(Row, {
                        gap: 8,
                        alignItems: "center",
                        justifyContent: "end",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                bi: {
                                    name: 'dismiss_simple_confirmation'
                                },
                                skin: "primaryOutline",
                                testId: SimpleConfirmationMessageTID.Dismiss(),
                                onClick: ()=>onDismiss(messageId),
                                children: content.dismissLabel
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                bi: {
                                    name: 'apply_simple_confirmation'
                                },
                                testId: SimpleConfirmationMessageTID.Apply(),
                                onClick: ()=>onApply(messageId, []),
                                children: content.applyLabel
                            })
                        ]
                    })
                ]
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
